import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from "../../shared/shared.module";
import {LoginComponent} from "./login.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

export const LoginRoutes: Routes = [
  {
    path: '',
    component: LoginComponent,
    data: {
      breadcrumb: 'Login',
      icon: 'icofont-social-blogger bg-c-green',
      breadcrumb_caption: 'Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit - Change Log',
      status: true
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(LoginRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [LoginComponent]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/pages/Nlogin/login.module.ts